var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlycolBath(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3947 14.5714C22.0023 14.5714 21.6842 14.8912 21.6842 15.2857V21C21.6842 21.3945 22.0023 21.7143 22.3947 21.7143C22.7871 21.7143 23.1053 21.3945 23.1053 21V15.2857C23.1053 14.8912 22.7871 14.5714 22.3947 14.5714Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5592 9.54286C22.3267 7.42362 20.0393 6 17.4211 6C13.8198 6 10.8443 8.6934 10.379 12.1857H9.36183L9.35544 12.1905H3.31818C2.86631 12.1905 2.5 12.5864 2.5 13.0748V26H29.5V10.4272C29.5 9.95635 29.1596 9.57144 28.7302 9.54436C28.7142 9.53978 28.6981 9.53742 28.6818 9.53742H24.5263V9.54286H23.5592ZM21.8356 9.54286C20.7934 8.25287 19.203 7.42857 17.4211 7.42857C14.6045 7.42857 12.2664 9.4879 11.8154 12.1905H15.5909V10.4218C15.5909 9.93336 15.9572 9.53742 16.4091 9.53742H18.8421V9.54286H21.8356ZM4.63158 23.8V14.3857H17.2932V11.7285H27.3684V23.8H4.63158Z",
    fill: "white",
    fillOpacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlycolBath);
export default __webpack_public_path__ + "static/media/glycol_bath.19afd3ed12c8482d8a1ae0859c2097bf.svg";
export { ForwardRef as ReactComponent };